import { render, staticRenderFns } from "./IboxFooter.vue?vue&type=template&id=6d8ea67f&scoped=true&"
import script from "./IboxFooter.vue?vue&type=script&lang=js&"
export * from "./IboxFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ea67f",
  null
  
)

export default component.exports